<script>
import Chip from "./Chip";

export default {
  props: {
    orderActive: {
      type: Number,
      required: false,
      default: 0
    },
    statuses: {
      type: Array,
      required: true
    },
    visible: {
      type: Boolean,
      required: true
    }
  },
  components: {
    Chip
  }
};
</script>

<template>
  <v-layout row justify-center>
    <v-dialog :value="visible" persistent max-width="600">
      <v-card>
        <v-layout class="pr-15 header" row align-center>
          <v-flex>
            <v-card-title class="title mb-0 pb-0"
              >Estados da conta</v-card-title
            >
            <v-card-text class="body-1 pt-1"
              >Abaixo estão os possíveis estados com sua ordenação.</v-card-text
            >
          </v-flex>

          <v-btn color="error" outlined icon @click="$emit('close')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-layout>
        <v-divider></v-divider>

        <v-container class="pt-2 pb-2">
          <v-timeline dense>
            <v-timeline-item
              v-for="(status, index) in statuses"
              :key="index"
              :color="status.color"
              :icon="status.icon"
              fill-dot
            >
              <v-card class="elevation-2">
                <v-card-title
                  class="subheading font-weight-bold text-uppercase mb-0 py-0 pt-10"
                >
                  {{ status.order }} - {{ status.name }}
                  <v-icon v-if="status.order <= orderActive" color="green"
                    >check</v-icon
                  >
                </v-card-title>

                <v-card-text class="py-0 pb-10">
                  {{ status.description }}
                </v-card-text>
              </v-card>
            </v-timeline-item>
          </v-timeline>
        </v-container>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<style scoped>
.header {
  margin: 0;
  padding-right: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Users/Status/Statuses.vue